import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { API_KEY_ROLE_BINDING_DELETE } from "./gql";

export const useBulkApiKeyRoleDelete = createBulkMutationHook(API_KEY_ROLE_BINDING_DELETE);

const useApiKeyRoleDelete = createDefaultMutationHook(API_KEY_ROLE_BINDING_DELETE);
export default useApiKeyRoleDelete;